import { useQuery } from "@tanstack/react-query";
import api from "../services/api";
import { listSamplesKey } from "./queryKeys";
import { SearchGridData } from "../modules/search/@types";
import { ISamplesQuery } from "./@types";

const useListSamples = (
  query?: ISamplesQuery | undefined
): {
  samples: SearchGridData;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
} => {
  const hasQueryParams = !!query;
  const {
    data,
    isSuccess,
    isPending: isLoading,
    isError
  } = useQuery({
    queryKey: listSamplesKey(query),
    queryFn: () => api.listSamples(query),
    enabled: hasQueryParams,
    refetchOnMount: false
  });

  return {
    samples: data?.data?.data,
    isLoading: hasQueryParams ? isLoading : false,
    isSuccess,
    isError
  };
};

export default useListSamples;
